import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchClientProgressPhotoUrl,
  fetchClientProgressPhotos,
  fetchProgressPhotoUrl,
  fetchProgressPhotos,
} from '../api/progressPhotos.api';

export const statsProgressPhotosQueryKeys = createQueryKeys(
  'statsProgressPhotos',
  {
    // `clientId` present = trainer/admin READ of a client's photos; absent = self.
    // A single factory per concern keeps the query-key shape uniform (no union).
    fetchPhotoUrl: ({ id, clientId }: { id: string; clientId?: string }) => ({
      queryFn: () =>
        clientId
          ? fetchClientProgressPhotoUrl({ clientId, id })
          : fetchProgressPhotoUrl({ id }),
      queryKey: [clientId ?? 'self', id],
    }),
    fetchPhotos: (clientId?: string) => ({
      queryFn: () =>
        clientId ? fetchClientProgressPhotos(clientId) : fetchProgressPhotos(),
      queryKey: [clientId ?? 'self'],
    }),
  },
);
